import { memo } from "react";

import OwnerAnimalSelect from "../../components/multiforms/OwnerAnimalSelect";

const SelectLambing = () => {
    return (
        <OwnerAnimalSelect type={"SelectLambing"} />
    )
};

export default memo(SelectLambing)